import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { APP_SETTINGS, ToastConfigService } from '@services';
import { AuthService } from '../../../core/services/auth/auth.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { UserProfileService } from '../../user-profile/user-profile.service';
import { AdminService } from '../admin.service';
import { FormsModule } from '@angular/forms';
import { NgClass, NgFor, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';
import { SearchFilterPipe } from '../../../shared/pipes/search-filter.pipe';
@Component({
    selector: 'app-show-messages',
    templateUrl: './show-messages.component.html',
    styleUrls: ['./show-messages.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FormsModule,
        NgClass,
        NgFor,
        RouterLink,
        NgStyle,
        SearchFilterPipe,
    ],
})
export class ShowMessagesComponent implements OnInit {

  constructor(
    private adminService: AdminService,
    private toastService: ToastConfigService,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    private userProfileService: UserProfileService,
    private cdr: ChangeDetectorRef
  ) { }

  public allMessages: any[] = [];
  private userEmail = '';
  public makeName = 'BMW';
  search4messages: string;
  APP_SETTINGS: any;
  private userSelectedMessageObject: any;

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
      this.userEmail = userData['email'];
      this.cdr.markForCheck();
    });
    this.getAllMessages();
  }

  getAllMessages() {
    this.spinnerService.show('bmwSpinner');
    this.adminService.getAllMessagesAdmin(this.makeName).subscribe(data => {
      if (this.makeName == 'BMW') {
        this.allMessages = data.filter(filtermessage => filtermessage['isBMW'] === true);
      }
      if (this.makeName == 'MINI') {
        this.allMessages = data.filter(filtermessage => filtermessage['isMINI'] === true);
      }
      if (this.makeName == 'MOTORRAD') {
        this.allMessages = data.filter(filtermessage => filtermessage['isMOTORRAD'] === true);
      }
      if (this.makeName == 'ROLLSROYCE') {
        this.allMessages = data.filter(filtermessage => filtermessage['isROLLSROYCE'] === true);
      }

      this.spinnerService.hide('bmwSpinner');
      this.cdr.markForCheck();
    });
  }
  
  holdMessageForAction(message) {
    this.userSelectedMessageObject = message;
  }
  reactivateDeactivateMessage() {
    if (this.userSelectedMessageObject['isActive']) {
      this.deactivateMessage(this.userSelectedMessageObject);
    } else {
      this.reactivateMessage(this.userSelectedMessageObject);
    }
  }
  reactivateMessage(messageObj) {
    this.spinnerService.show('bmwSpinner');
    this.adminService.reactivateMessage(messageObj.id, this.userEmail, this.makeName).subscribe(data => {
      if (data) {
        this.spinnerService.hide('bmwSpinner');
        this.toastService.popToast('Message Reactivated');
        this.getAllMessages();
      }
    });
  }
  deactivateMessage(messageObj) {
    this.spinnerService.show('bmwSpinner');
    this.adminService.deactivateMessage(messageObj.id, this.userEmail, this.makeName).subscribe(data => {
      if (data) {
        this.spinnerService.hide('bmwSpinner');
        this.toastService.popToast('Message Deactivated');
        this.getAllMessages();
      }
    });
  }

}
